import { useEffect, useState } from "react";
import { Box, Typography, Link, ListItemText } from "@mui/material";
import { styled, useTheme } from '@mui/material/styles';
import { readAppLastUpdateDate } from "../../services/qlikService";
import { QLIK_APP_REF } from "../../constants/qlik";

interface LastUpdateProps {
  componentLocation: "header" | "nav";
  expanded?: boolean;
}

const BorderedContent = styled(Box)(({ theme }) => ({
  borderRight: `4px solid ${theme.palette.primary.main}`,
  paddingRight: theme.spacing(2)
}));

export const LastUpdate: React.FC<LastUpdateProps> = ({ componentLocation, expanded }) => {
  const [lastUpdatedDate, setLastUpdatedDate] = useState<string>("");
  const theme = useTheme();

  useEffect(() => {
    const getUpdateDate = async () => {
        try {
          const lastUpdateDate = await readAppLastUpdateDate(QLIK_APP_REF);
          setLastUpdatedDate(
            new Date(lastUpdateDate).toLocaleDateString('en-US')
          );
        } catch (err) {
          setLastUpdatedDate("N/A");
        }
    }
    getUpdateDate();
  }, []);

  if (componentLocation === "header") {
    return (
        <BorderedContent>
            <Typography variant="subtitle1">
            Last Updated:
            <br />
            {lastUpdatedDate}
            </Typography>
        </BorderedContent>
    );
  }

  if (componentLocation === "nav") {
    return (
      <ListItemText
        primary={`Last Updated: ${lastUpdatedDate}`}
        slotProps={{ primary: { noWrap: true, sx: { fontSize: '1rem' }} }}
        sx={{
          opacity: expanded ? 1 : 0,
          transition: theme.transitions.create('opacity', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
      >
      </ListItemText>
    );
  }

  return null;
};

export default LastUpdate;